import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';

import * as componentActions from '@catdetails/actions/project-features';

@Injectable()
export class ProjectDetailsFeaturesService {
  constructor(private store: Store<any>) {
  }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_FEATURES_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_FEATURES_DEACTIVATE});
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/services/project-details-features.service.ts